import { render, staticRenderFns } from "./ProjectCard.vue?vue&type=template&id=3ae74adb&scoped=true&"
import script from "./ProjectCard.vue?vue&type=script&lang=js&"
export * from "./ProjectCard.vue?vue&type=script&lang=js&"
import style0 from "./ProjectCard.vue?vue&type=style&index=0&id=3ae74adb&lang=scss&scoped=true&"
import style1 from "./ProjectCard.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae74adb",
  null
  
)

export default component.exports